export const localisedPath = url => {
  if (!url.length) return url;
  if (gon.current_store.available_locales.length < 2) return url;
  const urlPattern = /^https?:\/\//i;
  if (urlPattern.test(url)) return url;

  return `/${global.translations.locale}/${url}`.replace(/\/\//g, '/');
};

export const switchToLocale = locale => {
  return (window.location.search += `&switch_locale=${locale}`);
};
